import type { OtcAmountAnchor } from "../types/cryptoSwaps.types";

export const BUY_URL_PARAMS = {
  pay: "pay",
  receive: "receive",
  network: "network",
  organization: "org",
} as const;

const AMOUNT_RE: Record<OtcAmountAnchor, RegExp> = {
  send: /^\d{1,12}$/,
  receive: /^\d{1,12}(\.\d{1,2})?$/,
};
const NETWORK_RE = /^[A-Z0-9_]{2,16}$/;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface BuyUrlState {
  anchor: OtcAmountAnchor;
  amount: string;
  network: string;
  organizationId: string | null;
}

export function readBuyUrlState(params: URLSearchParams): BuyUrlState {
  const pay = params.get(BUY_URL_PARAMS.pay) ?? "";
  const receive = params.get(BUY_URL_PARAMS.receive) ?? "";
  const network = params.get(BUY_URL_PARAMS.network) ?? "";
  const organization = params.get(BUY_URL_PARAMS.organization) ?? "";
  const payValid = AMOUNT_RE.send.test(pay);
  const anchor: OtcAmountAnchor = !payValid && AMOUNT_RE.receive.test(receive) ? "receive" : "send";
  return {
    anchor,
    amount: anchor === "send" ? (payValid ? pay : "") : receive,
    network: NETWORK_RE.test(network) ? network : "",
    organizationId: UUID_RE.test(organization) ? organization : null,
  };
}

export function buyUrlSearch(state: BuyUrlState): string {
  const params = new URLSearchParams();
  const amount = state.amount.trim();
  if (AMOUNT_RE[state.anchor].test(amount)) {
    params.set(state.anchor === "send" ? BUY_URL_PARAMS.pay : BUY_URL_PARAMS.receive, amount);
  }
  if (state.network) params.set(BUY_URL_PARAMS.network, state.network);
  if (state.organizationId) params.set(BUY_URL_PARAMS.organization, state.organizationId);
  return params.toString();
}
